import { Button, Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  isCancelDialogOpen: boolean;
  setCancelDialog: (state: boolean) => void;
  onClickCancelButton: (_: any) => void;
  descriptionId?: string;
  cancelButtonTitleId?: string;
  submitButtonTitleId?: string;
  className?: string;
};

const InputCancelDialog: FC<Props> = ({
  isCancelDialogOpen,
  setCancelDialog,
  onClickCancelButton,
  descriptionId,
  cancelButtonTitleId,
  submitButtonTitleId,
  className,
}) => {
  return (
    <Dialog open={isCancelDialogOpen} maxWidth="lg" className={className}>
      <DialogContent>
        <Typography>
          <FormattedMessage id={descriptionId ? descriptionId : 'modification_request.cancel_dialog.description'} />
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="text" color="default" onClick={() => setCancelDialog(false)}>
          <FormattedMessage
            id={cancelButtonTitleId ? cancelButtonTitleId : 'modification_request.cancel_dialog.cancel'}
          />
        </Button>

        <Button
          variant="text"
          onClick={(e) => {
            setCancelDialog(false);
            onClickCancelButton(e);
          }}
        >
          <FormattedMessage
            id={submitButtonTitleId ? submitButtonTitleId : 'modification_request.cancel_dialog.submit'}
          />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InputCancelDialog;
